class CountdownTimer extends HTMLElement {
    constructor() {
        super();

        // Configurable options
        this.options = {
            timeZone: "America/New_York",
            hideClass: 'hidden'
        }

        // Placeholder memory
        this.settings = {};

        this._init = this._init.bind(this);
        this._getCurrentTime = this._getCurrentTime.bind(this);
        this._getCountryCode = this._getCountryCode.bind(this);
        this._checkTimerDisplayConditions = this._checkTimerDisplayConditions.bind(this);

        this._init();

        setInterval(() => {
            this._checkTimerDisplayConditions();
        }, 1000);
    }

    _init() {
        this.timeNow = this._getCurrentTime();

        // Settings pulled from HTML
        this.settings = {
            countryCode: this._getCountryCode(),
            timeStart: this.dataset.timeStart,
            timeEnd: this.timeNow,
            visibilityRule: this.dataset.visibilityRule,
            visibilityCountries: this.dataset.visibilityCountries.split(',').map((country) => country.trim()), // Get array of countries
            visibilityDays: this.dataset.visibilityDays.split(',').map((day) => day.trim()).map(Number) // Get array of days | parse from string
        }

        // DOM Selectors
        this.selectors = {
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]')
        }

        // Parse end time
        let parsedEndHours = Math.floor(Number(this.dataset.timeEnd) / 100),
            parsedEndMinutes = this.dataset.timeEnd % 100;


        this.settings.timeEnd.setHours(parsedEndHours);
        this.settings.timeEnd.setMinutes(parsedEndMinutes);
    }

    _getCountryCode() {
        // Get Country Code from memory or pull from API Orbito
        if (typeof orbito !== 'undefined' && orbito.remoteCountryCode) {
            return orbito.remoteCountryCode;
        } else {
            console.warn('Orbito remoteCountryCode is not available.');
            return null;
        }
    }
    _getCurrentTime() {
        return new Date(new Date().toLocaleString("en-US", { timeZone: this.options.timeZone }));
    }
    _renderTimer() {
        // Calc logic
        let timeDifference = this.settings.timeEnd - this.timeNow,
            remainingHours = String(Math.floor(timeDifference / (1000 * 60 * 60))).padStart(2, '0'),
            remainingMinutes = String(Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');

        if (this.selectors.hours && this.selectors.minutes) {
            // DOM Manipulations
            this.selectors.hours.textContent = remainingHours;
            this.selectors.minutes.textContent = remainingMinutes;
        }
    }

    _checkTimerDisplayConditions() {
        this.timeNow = this._getCurrentTime();

        // Hack to always have 4 digits for comperasion
        const timeDifference = this.settings.timeEnd - this.timeNow,
            comparisonTimeNow = Number(`${this.timeNow.getHours().toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            })}${this.timeNow.getMinutes().toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            })}`);


        // If the user's country is not included in the list and should be included, or if the user's country is included in the list and should be excluded, skip starting the timer
        if ((this.settings.visibilityRule === 'include' && !this.settings.visibilityCountries.includes(this.settings.countryCode)) ||
            (this.settings.visibilityRule === 'exclude' && this.settings.visibilityCountries.includes(this.settings.countryCode))) {
            this.classList.add(this.options.hideClass);
            return;
        }

        // If the current day of the week is not enabled, hide the timer
        if(!this.settings.visibilityDays.includes(this.timeNow.getDay())) {
            this.classList.add(this.options.hideClass)
            return;
        } else {
            this.classList.remove(this.options.hideClass);
        }

        // Check time diapazone and show/hide timer
        //* check if timer have pass it's time
        comparisonTimeNow >= this.settings.timeStart && timeDifference > 0
            ? this.classList.remove(this.options.hideClass)
            : this.classList.add(this.options.hideClass);

        this._renderTimer();
    }
}
customElements.define("countdown-timer", CountdownTimer);